import {
  usePopoverDescription
} from "./SRHDWRFI.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";

// src/hovercard/hovercard-description.ts
var useHovercardDescription = createHook(
  (props) => {
    props = usePopoverDescription(props);
    return props;
  }
);
var HovercardDescription = createComponent((props) => {
  const htmlProps = useHovercardDescription(props);
  return createElement("p", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  HovercardDescription.displayName = "HovercardDescription";
}

export {
  useHovercardDescription,
  HovercardDescription
};
